import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import IssuesServices from "services/IssuesServices";

export const addNewIssue = createAsyncThunk("/issues/new", async (formData) => {
  const res = await IssuesServices.addNewIssueApi(formData);
  return res.data;
});

export const addNewLetter = createAsyncThunk(
  "/letters/new",
  async (formData) => {
    const res = await IssuesServices.addNewLetterApi(formData);
    return res.data;
  }
);

export const updateLetter = createAsyncThunk(
  "/letters/update",
  async ({ id, data }) => {
    const res = await IssuesServices.updateLetterApi(id, data);
    return res.data;
  }
);

export const fetchAllIssues = createAsyncThunk(
  "/issues/all",
  async ({ page, limit, status, search, startDate, endDate, projectId }) => {
    const res = await IssuesServices.getAllIssuesApi(
      page,
      limit,
      status,
      search,
      startDate,
      endDate,
      projectId
    );
    return res.data;
  }
);
export const fetchSingleIssue = createAsyncThunk(
  "/issue/details",
  async ({ id }) => {
    const res = await IssuesServices.getSingleIssue(id);
    return res.data;
  }
);
export const updateIssue = createAsyncThunk(
  "/issues/update",
  async ({ id, data }) => {
    const res = await IssuesServices.updateIssueApi(id, data);
    return res.data;
  }
);
export const updateActivity = createAsyncThunk(
  "/issues/update_activity",
  async ({ id, data }) => {
    const res = await IssuesServices.updateActivityApi(id, data);
    return res.data;
  }
);
export const updateFiles = createAsyncThunk(
  "/issues/update_files",
  async ({ id, data }) => {
    const res = await IssuesServices.updateIssueFilesApi(id, data);
    return res.data;
  }
);
export const deleteFiles = createAsyncThunk(
  "/issues/delete_files",
  async ({ id, data }) => {
    const res = await IssuesServices.deleteFilesApi(id, data);
    return res.data;
  }
);

export const deleteLetterFiles = createAsyncThunk(
  "/letters/delete_files",
  async ({ id, data }) => {
    const res = await IssuesServices.deleteLetterFilesApi(id, data);
    return res.data;
  }
);

export const deleteIssue = createAsyncThunk(
  "/issues/delete",
  async ({ id }) => {
    const res = await IssuesServices.deleteApi(id);
    return res.data;
  }
);

export const deleteLetter = createAsyncThunk(
  "/letters/delete",
  async ({ id }) => {
    const res = await IssuesServices.deleteLetterApi(id);
    return res.data;
  }
);

export const clearSavedId = createAsyncThunk(
  "clearId",
  async ({ createdId }) => {
    return createdId;
  }
);

export const clearDeletedArray = createAsyncThunk(
  "deleted",
  async ({ deleted }) => {
    return deleted;
  }
);

export const takeIssueData = createAsyncThunk(
  "issueData",
  async ({ issueData }) => {
    return issueData;
  }
);
const issuesSlice = createSlice({
  name: "issues",
  initialState: {
    loading: false,
    allIssuesData: [],
    total: null,
    totalPages: 1,
    details: {},
    createdId: null,
    deleted: false,
    issueData: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(addNewIssue.pending, (state) => {
        state.loading = true;
      })
      .addCase(addNewIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.createdId = action.payload.data.id;
        toast.success("Issue submitted sucessfully");
      })
      .addCase(addNewIssue.rejected, (state, action) => {
        state.loading = false;
        toast.error("Failed to create new issue.");
      })
      .addCase(addNewLetter.pending, (state) => {
        state.loading = true;
      })
      .addCase(addNewLetter.fulfilled, (state, action) => {
        state.loading = false;
        state.createdId = action.payload.data.id;
        toast.success("Letter submitted sucessfully");
      })
      .addCase(addNewLetter.rejected, (state, action) => {
        state.loading = false;
        toast.error("Failed to submit new letter.");
      })
      .addCase(updateIssue.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.createdId = action.payload.data.id;
        toast.success("Issue Updated sucessfully");
      })
      .addCase(updateIssue.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateActivity.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload.data;
        toast.success("Activity details Updated sucessfully");
      })
      .addCase(updateActivity.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateFiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateFiles.fulfilled, (state, action) => {
        state.loading = false;
        state.createdId = action.payload.data.id;
        toast.success("Files Updated sucessfully");
      })
      .addCase(updateFiles.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(fetchAllIssues.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllIssues.fulfilled, (state, action) => {
        state.loading = false;
        state.allIssuesData = action.payload.data;
        state.total = action.payload.total;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchAllIssues.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(fetchSingleIssue.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSingleIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload.data;
      })
      .addCase(fetchSingleIssue.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteFiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFiles.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload.data;
        state.deleted = true;
        toast.success("Selected files deleted sucessfully");
      })
      .addCase(deleteFiles.rejected, (state, action) => {
        state.loading = false;
        toast.error("Failed to delete files");
      })

      .addCase(clearSavedId.fulfilled, (state, action) => {
        state.createdId = null;
      })
      .addCase(clearDeletedArray.fulfilled, (state, action) => {
        state.deleted = false;
      })
      .addCase(deleteIssue.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteIssue.fulfilled, (state, action) => {
        state.loading = false;
        toast.success("Issue Deleted sucessfully");
      })
      .addCase(deleteIssue.rejected, (state, action) => {
        state.loading = false;
        toast.error("Failed to delete issue.");
      })
      .addCase(takeIssueData.fulfilled, (state, action) => {
        state.issueData = action.payload;
      })
      .addCase(updateLetter.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateLetter.fulfilled, (state, action) => {
        state.loading = false;
        state.createdId = action.payload.data.id;
        toast.success("Letter Updated sucessfully");
      })
      .addCase(updateLetter.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteLetterFiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteLetterFiles.fulfilled, (state, action) => {
        state.loading = false;
        state.details = action.payload.data;
        state.deleted = true;
        toast.success("Selected files deleted sucessfully");
      })
      .addCase(deleteLetterFiles.rejected, (state, action) => {
        state.loading = false;
        toast.error("Failed to delete files");
      })
      .addCase(deleteLetter.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(deleteLetter.fulfilled, (state, action) => {
        state.loading = false;
        toast.success("Letter Deleted sucessfully");
      })
      .addCase(deleteLetter.rejected, (state, action) => {
        state.loading = false;
        toast.error("Failed to delete letter.");
      });
  },
});

const { reducer } = issuesSlice;
export default reducer;
